module.exports = __webpack_public_path__ + "static/media/400415_01.e3ecc453.png";